import { render, staticRenderFns } from "./NumberAdd.vue?vue&type=template&id=7a53bd07&scoped=true"
import script from "./NumberAdd.vue?vue&type=script&lang=js"
export * from "./NumberAdd.vue?vue&type=script&lang=js"
import style0 from "./NumberAdd.vue?vue&type=style&index=0&id=7a53bd07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a53bd07",
  null
  
)

export default component.exports